import { useState, useEffect } from "react";

function useBrowserNotification() {
  const [permission, setPermission] = useState(Notification.permission);

  useEffect(() => {
    if (permission === "default") {
      Notification.requestPermission().then((permission) => {
        setPermission(permission);
      });
    }
  }, [permission]);

  const showNotification = (title, options) => {
    if (document.hasFocus()) {
      return;
    }
    const notificationOptions = { ...options, silent: true };
    if (permission === "granted") {
      const notification = new Notification(title, notificationOptions);
      setTimeout(() => notification.close(), 2000);
    } else if (permission !== "denied") {
      Notification.requestPermission().then((permission) => {
        setPermission(permission);
        if (permission === "granted") {
          new Notification(title, notificationOptions);
        }
      });
    }
  };

  return showNotification;
}

export default useBrowserNotification;
